<template>
	<div>
	<input
		class
		id="boolean-true"
		:value="true"
		v-model="picked"
		type="radio"
	/> <label class="ml-1" for="boolean-true">TRUE</label>
	<input
		class="ml-4"
		id="boolean-false"
		:value="false"
		v-model="picked"
		type="radio"
	/> <label class="ml-1" for="boolean-false">FALSE</label>
	</div>
</template>
<script>
/** @format */

export default {
	name: 'BaseBoolean',
	props: {
		label: {
			type: String
		},
		value: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		displayedPlaceholder() {
			if (this.placeholder) return this.placeholder;
			if (this.label) return this.label;
			return '';
		}
	},
	watch: {
		picked(b){
			this.$emit('input', b);
		}
	},
	mounted() {
		this.$emit('input', this.picked);
	},
	data() {
		return {
			picked: this.value || false,
		}
	}
};
</script>
